import { activeLocations } from './activeEnrollmentLocations'

const getEnrollmentLocationData = () => Promise.resolve(activeLocations)

export default getEnrollmentLocationData
